<admin-app-header></admin-app-header>

<div class="aff-page">
    <div class="container-fluid">
        <div class="page-header">
            <div>
                <h1>Affiliates</h1>
                <p class="subtitle">Users who refer parkers and landlords for commission.</p>
            </div>
            <div class="page-header__actions">
                <a class="btn btn-secondary" [routerLink]="['/admin/affiliate-guide']"><i class="fa-solid fa-book"></i> Guide</a>
                <a class="btn btn-secondary" [routerLink]="['/admin/affiliate-payouts']"><i class="fa-solid fa-money-bill-transfer"></i> Payouts &amp; reports</a>
                <button class="btn btn-primary" (click)="openCreate()"><i class="fa-solid fa-plus"></i> New affiliate</button>
            </div>
        </div>

        <div class="stats-grid">
            <div class="stat">
                <span class="stat__value">{{ rows.length }}</span>
                <span class="stat__label">Affiliates</span>
            </div>
            <div class="stat">
                <span class="stat__value">{{ totalClicks | number }}</span>
                <span class="stat__label">Link visits</span>
            </div>
            <div class="stat">
                <span class="stat__value">{{ totalReferrals | number }}</span>
                <span class="stat__label">Referrals</span>
            </div>
            <div class="stat">
                <span class="stat__value">R {{ total('revenueAttributed') | number: '1.0-0' }}</span>
                <span class="stat__label">Revenue attributed</span>
            </div>
            <div class="stat stat--orange">
                <span class="stat__value">R {{ total('pending') + total('approved') + total('requested') | number: '1.0-0' }}</span>
                <span class="stat__label">Owed (incl. pending)</span>
            </div>
            <div class="stat stat--green">
                <span class="stat__value">R {{ total('paid') | number: '1.0-0' }}</span>
                <span class="stat__label">Paid out</span>
            </div>
        </div>

        <div class="tabs">
            <button [class.active]="tab === 'affiliates'" (click)="setTab('affiliates')">Affiliates<span class="count">{{ rows.length }}</span></button>
            <button [class.active]="tab === 'landlords'" (click)="setTab('landlords')">Landlord &amp; building introductions</button>
            <a class="btn btn-secondary btn-sm" *ngIf="openRequests" [routerLink]="['/admin/affiliate-payouts']" style="margin-left: auto; align-self: center">
                {{ openRequests }} payout request{{ openRequests === 1 ? '' : 's' }} waiting
            </a>
        </div>

        <!-- Affiliates -->
        <div class="card" *ngIf="tab === 'affiliates'">
            <div class="card__head">
                <h2>All affiliates</h2>
                <div class="filters">
                    <div class="field">
                        <select [(ngModel)]="kindFilter">
                            <option value="all">All types</option>
                            <option *ngFor="let k of kinds" [value]="k">{{ kindLabel(k) }}</option>
                        </select>
                    </div>
                    <div class="field"><input placeholder="Search name, email, phone or code" [(ngModel)]="search" /></div>
                </div>
            </div>
            <div class="loading" *ngIf="loading"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
            <div class="empty" *ngIf="!loading && !rows.length">No affiliates yet. Add one from an existing ParkUpp user, or add a security guard (no login needed).</div>
            <div class="table-wrap" *ngIf="!loading && rows.length">
                <table class="aff-table">
                    <thead>
                        <tr>
                            <th>Affiliate</th>
                            <th>Code</th>
                            <th>Status</th>
                            <th class="num">Visits</th>
                            <th class="num">Sign-ups</th>
                            <th class="num">Parkers</th>
                            <th class="num">Buildings</th>
                            <th class="num" title="Fee share % of Trading Income (parker / building), or a guard's bounty per parker">Payout terms</th>
                            <th class="num">Revenue</th>
                            <th class="num">This month</th>
                            <th class="num" title="On statements, or guard bounties due">Owed</th>
                            <th class="num">Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of filteredRows" class="clickable" (click)="open(r)">
                            <td>
                                {{ r.displayName }}
                                <span class="sub">
                                    <span class="badge" [ngClass]="r.kind === Kind.SECURITY_GUARD ? 'badge--guard' : r.kind === Kind.LANDLORD_PROMOTER ? 'badge--landlord' : 'badge--parker'">{{
                                        kindLabel(r.kind)
                                    }}</span>
                                    {{ r.accountless ? r.phone || 'No login' : r.email }}
                                </span>
                            </td>
                            <td>
                                <strong>{{ r.code }}</strong>
                            </td>
                            <td><span class="badge" [ngClass]="'badge--' + r.status">{{ r.status | titlecase }}</span></td>
                            <td class="num">{{ r.stats.uniqueClicks | number }}</td>
                            <td class="num">{{ r.stats.signups | number }}</td>
                            <td class="num">{{ r.stats.parkerReferrals | number }}</td>
                            <td class="num">{{ r.stats.buildingReferrals || 0 | number }}</td>
                            <ng-container *ngIf="r.kind !== Kind.SECURITY_GUARD">
                                <td class="num">{{ r.parkerCommissionPct }}% / {{ r.landlordCommissionPct }}%</td>
                                <td class="num">R {{ r.revenueAttributed | number: '1.0-0' }}</td>
                                <td class="num">R {{ r.balances.pending + r.balances.approved | number: '1.2-2' }}</td>
                                <td class="num">R {{ r.balances.requested | number: '1.2-2' }}</td>
                                <td class="num">R {{ r.balances.paid | number: '1.2-2' }}</td>
                            </ng-container>
                            <ng-container *ngIf="r.kind === Kind.SECURITY_GUARD">
                                <td class="num">R{{ r.bountyAmount }} after {{ r.bountyPaidInvoices }} paid</td>
                                <td class="num"><span class="sub">—</span></td>
                                <td class="num"><span class="sub">—</span></td>
                                <td class="num">R {{ r.bountiesDue | number: '1.2-2' }}</td>
                                <td class="num">R {{ r.bountiesPaid | number: '1.2-2' }}</td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Landlord & building introductions -->
        <div class="card" *ngIf="tab === 'landlords'">
            <div class="card__head">
                <div>
                    <h2>Landlord &amp; building introductions</h2>
                    <p class="muted">
                        Fee shares are paid <strong>per building</strong>, for 12 months from the date the building is first listed. A <strong>landlord introduction</strong> doesn't earn
                        on its own: it records who introduced the landlord, and that landlord's buildings first listed within {{ defaults.buildingAutoCreditDays }} days are credited to the
                        same affiliate automatically. Credit any other building by hand.
                    </p>
                </div>
                <div class="filters">
                    <div class="field">
                        <select [(ngModel)]="landlordFilter">
                            <option value="all">All</option>
                            <option value="attributed">Credited buildings</option>
                            <option value="unattributed">Buildings not credited</option>
                        </select>
                    </div>
                    <div class="field"><input placeholder="Search portfolio, building or affiliate" [(ngModel)]="search" /></div>
                </div>
            </div>
            <div class="loading" *ngIf="!landlordsLoaded"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
            <div class="table-wrap" *ngIf="landlordsLoaded">
                <table class="aff-table">
                    <thead>
                        <tr>
                            <th>Portfolio / building</th>
                            <th>First listed</th>
                            <th>ParkUpp fee</th>
                            <th>Introduced by</th>
                            <th>Fee share period</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let l of filteredLandlords">
                            <tr class="portfolio-row">
                                <td>
                                    <i class="fa-solid fa-briefcase"></i> <a [routerLink]="['/merchant', l.merchantKey]"><strong>{{ l.companyName }}</strong></a>
                                    <span class="sub">Portfolio created {{ l.createdAt | date: 'd MMM y' }}{{ l.denormEnterpriseKey !== 'parkupp' ? ' · ' + l.denormEnterpriseKey : '' }}</span>
                                </td>
                                <td></td>
                                <td>
                                    <span *ngIf="l.commissionPercentage !== null">{{ l.commissionPercentage }}%</span>
                                    <span *ngIf="l.commissionPercentage === null" class="sub" title="No rate on the portfolio. Fee share maths uses what the landlord payout uses.">not set (uses {{ l.effectivePlatformPct }}%)</span>
                                </td>
                                <td>
                                    <ng-container *ngIf="l.introduction as r">
                                        <a [routerLink]="['/admin/affiliates', r.affiliateUid]" [class.strike]="r.status !== 'active'">{{ r.affiliateName }}</a>
                                        <span class="sub">Landlord introduction · {{ r.source === 'admin' ? 'added by admin' : 'via link' }}{{ r.status !== 'active' ? ' · removed' : '' }}</span>
                                    </ng-container>
                                    <span *ngIf="!l.introduction" class="sub">—</span>
                                </td>
                                <td><span class="sub">Doesn't earn on its own</span></td>
                                <td class="num">
                                    <button class="btn btn-secondary btn-sm" (click)="openAttributeLandlord(l)">{{ l.introduction?.status === 'active' ? 'Change' : 'Introduced by…' }}</button>
                                    <button class="btn btn-danger btn-sm" *ngIf="l.introduction?.status === 'active'" (click)="revoke(l.companyName, l.introduction)">Remove</button>
                                </td>
                            </tr>
                            <tr *ngFor="let b of l.buildings">
                                <td style="padding-left: 36px">
                                    {{ b.title }}
                                    <span class="sub">{{ b.parkingStatus | titlecase }}</span>
                                </td>
                                <td>
                                    <span *ngIf="b.firstListedAt">{{ b.firstListedAt | date: 'd MMM y' }}</span>
                                    <span *ngIf="!b.firstListedAt" class="sub">{{ b.parkingStatus === 'PUBLISHED' ? 'Before tracking' : 'Not listed' }}</span>
                                </td>
                                <td></td>
                                <td>
                                    <ng-container *ngIf="b.referral as r">
                                        <a [routerLink]="['/admin/affiliates', r.affiliateUid]" [class.strike]="r.status !== 'active'">{{ r.affiliateName }}</a>
                                        <span class="sub">Building introduction · {{ r.source === 'admin' ? 'added by admin' : 'automatic' }}{{ r.status !== 'active' ? ' · removed' : '' }}</span>
                                    </ng-container>
                                    <span *ngIf="!b.referral" class="sub">—</span>
                                </td>
                                <td>
                                    <span *ngIf="b.referral?.status === 'active' && b.referral?.startsAt">{{ b.referral!.startsAt | date: 'd MMM y' }} – {{ b.referral!.endsAt | date: 'd MMM y' }}</span>
                                    <span *ngIf="b.referral?.status === 'active' && !b.referral?.startsAt" class="sub">Starts when first listed</span>
                                </td>
                                <td class="num">
                                    <button class="btn btn-secondary btn-sm" (click)="openAttributeBuilding(l, b)">{{ b.referral?.status === 'active' ? 'Change' : 'Credit' }}</button>
                                    <button class="btn btn-danger btn-sm" *ngIf="b.referral?.status === 'active'" (click)="revoke(b.title, b.referral)">Remove</button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Create affiliate -->
<div class="modal-backdrop-aff" *ngIf="showCreate" (click)="showCreate = false">
    <div class="modal-aff" (click)="$event.stopPropagation()">
        <h3>New affiliate</h3>
        <label class="field" style="margin-bottom: 16px"
            >Type
            <select [(ngModel)]="form.kind">
                <option *ngFor="let k of kinds" [value]="k">{{ kindLabel(k) }}</option>
            </select>
        </label>

        <!-- Promoters: an existing ParkUpp login -->
        <ng-container *ngIf="!isGuardForm">
            <p class="muted">
                Parker and landlord promoters need a ParkUpp account. They'll see an Affiliate page in their dashboard. The type is a label; both earn the fee share on any
                introduction.
            </p>
            <div class="filters" style="margin-bottom: 16px">
                <div class="field" style="flex: 1">
                    Email
                    <input type="email" [(ngModel)]="lookupEmail" (keyup.enter)="lookup()" placeholder="name@example.com" />
                </div>
                <button class="btn btn-secondary" (click)="lookup()" [disabled]="lookingUp">Find user</button>
            </div>
            <div class="notice notice--ok" *ngIf="found">
                <strong>{{ found.name }}</strong> · {{ found.email }}
            </div>
            <div class="form-grid" *ngIf="found">
                <label class="field">Code (optional)<input [(ngModel)]="form.code" placeholder="Generated if blank" maxlength="20" /></label>
                <span></span>
                <label class="field">Parker fee share (% of Trading Income)<input type="number" min="0" max="100" [(ngModel)]="form.parkerCommissionPct" /></label>
                <label class="field">Parker period (months from first booking)<input type="number" min="1" max="120" [(ngModel)]="form.parkerWindowMonths" /></label>
                <label class="field">Building fee share (% of Trading Income)<input type="number" min="0" max="100" [(ngModel)]="form.landlordCommissionPct" /></label>
                <label class="field">Building period (months from first listing)<input type="number" min="1" max="120" [(ngModel)]="form.landlordWindowMonths" /></label>
                <label class="field" style="grid-column: 1 / -1">Notes<textarea rows="2" [(ngModel)]="form.notes"></textarea></label>
            </div>
        </ng-container>

        <!-- Security guard: no login, created on their behalf -->
        <ng-container *ngIf="isGuardForm">
            <p class="muted">
                Security guards don't need a ParkUpp login. You create them here, give them their QR code (Sharing options on their page), and pay them a flat amount for each parker
                they bring once that parker has paid the set number of invoices. Paid by cash, airtime or EFT, recorded under Affiliate Payouts → Guard bounties.
            </p>
            <div class="form-grid">
                <label class="field" style="grid-column: 1 / -1">Name<input [(ngModel)]="form.displayName" maxlength="120" placeholder="e.g. Sipho Dlamini (Sandton City gate)" /></label>
                <label class="field">Cellphone (for airtime / contact)<input [(ngModel)]="form.phone" maxlength="30" inputmode="tel" /></label>
                <label class="field">Email (optional)<input type="email" [(ngModel)]="form.guardEmail" maxlength="200" /></label>
                <label class="field">Bounty per parker (R)<input type="number" min="0" [(ngModel)]="form.bountyAmount" /></label>
                <label class="field">Paid after this many paid invoices<input type="number" min="1" max="36" [(ngModel)]="form.bountyPaidInvoices" /></label>
                <label class="field">Code (optional)<input [(ngModel)]="form.code" placeholder="Generated if blank" maxlength="20" /></label>
                <span></span>
                <label class="field" style="grid-column: 1 / -1">Notes (site, agreement, how they prefer to be paid)<textarea rows="2" [(ngModel)]="form.notes"></textarea></label>
            </div>
        </ng-container>

        <div class="modal-aff__actions">
            <button class="btn btn-secondary" (click)="showCreate = false">Cancel</button>
            <button class="btn btn-primary" (click)="create()" [disabled]="!canCreate || saving">Create affiliate</button>
        </div>
    </div>
</div>

<!-- Attribute a landlord introduction or a building -->
<div class="modal-backdrop-aff" *ngIf="attributing" (click)="attributing = null">
    <div class="modal-aff" (click)="$event.stopPropagation()">
        <h3>{{ attributing.kind === 'building' ? 'Credit building' : 'Landlord introduction' }}: {{ attributing.name }}</h3>
        <p class="muted" *ngIf="attributing.kind === 'landlord'">
            Records who introduced this landlord. It doesn't earn on its own: buildings in this portfolio first listed within {{ defaults.buildingAutoCreditDays }} days are
            credited to the same affiliate automatically, including ones already listed in that time. Credit other buildings individually.
        </p>
        <p class="muted" *ngIf="attributing.kind === 'building'">
            The affiliate earns their building fee share on every bay in this building for 12 months from the date it was first listed. Payments before the start date, or after
            the 12 months, don't earn.
        </p>
        <div class="form-grid">
            <label class="field" style="grid-column: 1 / -1"
                >Affiliate
                <select [(ngModel)]="attribution.affiliateUid">
                    <option value="" disabled>Choose an affiliate</option>
                    <option *ngFor="let a of activeAffiliates" [value]="a.uid">{{ a.displayName }} ({{ a.code }})</option>
                </select>
            </label>
            <label class="field" *ngIf="attributing.kind === 'building'"
                >First listed (starts the 12 months)
                <input type="date" [(ngModel)]="attribution.listedAt" />
                <span class="sub" *ngIf="!attributing.firstListedAt">Not recorded (listed before tracking began). Enter the date it went live. If left blank: a live building uses its creation date; a building not yet live starts when it's first published.</span>
            </label>
            <label class="field" style="grid-column: 1 / -1">Notes (why: the introduction and the evidence)<textarea rows="2" [(ngModel)]="attribution.notes"></textarea></label>
            <label class="check" *ngIf="attributing.existing?.status === 'active'"
                ><input type="checkbox" [(ngModel)]="attribution.replace" /> Replace {{ attributing.existing?.affiliateName }}</label
            >
        </div>
        <div class="modal-aff__actions">
            <button class="btn btn-secondary" (click)="attributing = null">Cancel</button>
            <button class="btn btn-primary" (click)="saveAttribution()" [disabled]="!attribution.affiliateUid || saving">Save</button>
        </div>
    </div>
</div>
